// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__r1LA_","list":"PatternAutocomplete_list__3igdr"};